<template>
  <div class="successCases">
    <Nav></Nav>
    <div class="top-img">
      <img :src="jjtd" alt=""/>
    </div>
    <div class="team-info">
      <div class="lawyer-grid">
        <div
            v-for="(item, index) in info"
            :key="index"
            class="lawyer-item"

        >
          <div class="lawyer-avatar">
            <img :src="item.img" :alt="item.name">
          </div>
          <div class="lawyer-meta">
            <span class="name">{{ item.name }}</span>
            <span class="position">{{ item.position }}</span>
            <div class="intro-con">{{item.personalProfile}}</div>
            <div class="button" @click="personlDetail(item)">详细 →</div>
          </div>
        </div>
      </div>
    </div>
    <footer-con/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import FooterCon from '@/components/footer-con'
import jjtd from '@/assets/img/jjtd.png'
import dataList from './data'
export default {
  name: "contactUs",
  components: {
    Nav,
    FooterCon,
  },
  data() {
    return {
      info: [],
      jjtd,
      hoverIndex: -1
    };
  },
  created() {},
  mounted() {
    this.info = dataList
  },
  methods:{
    personlDetail(val){
      this.$router.push({
        path: '/jiujuTeam/personalInfo',
        query: {
          id: val.id,
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.successCases{
  height: 100%; /* 确保父容器高度为 100% */
}


.top-img{
  width: 100%;

  img{
    width: 100%;
    vertical-align: top;
  }
}

.team-info {
  width: 100%;
  padding: 10vh 10vw;
  box-sizing: border-box;
}

.lawyer-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 1.5vw;
}

.lawyer-item {
  flex: 0 0 calc(25% - 1.5vw);
  margin-bottom: 2vh;
  cursor: pointer;

  .lawyer-avatar {
    overflow: hidden;

    img {
      width: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }

  .lawyer-meta {
    margin-top: 32px;
    .name {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
    }

    .position {
      font-size: 16px;
      color: #AD867E;
      margin-left: 16px;
    }

    .intro-con{
      margin-top: 18px;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      line-height: 32px;
      display: -webkit-box; /* 弹性盒模型，用于控制行数 */
      -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      white-space: normal; /* 允许换行（默认，但需确保未设置为nowrap） */
    }
    .button{
      margin-top: 18px;
      width: 86px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #E6E6E6;
      text-align: center;
      line-height: 40px;
      color: #666;
    }
    .button:hover{
      background: #AD867E;
      border: 1px solid #E6E6E6;
      color: #fff;
      transition: transform 0.5s ease;
    }
  }
}
</style>
